import React from 'react'
import GroupsDoVd from '../GroupsDoVd'

export default function GroupsVD() {
    return <GroupsDoVd type={1} title="Группы ВД" />
}
